import { useParams } from "react-router";
import AdverseEvents from "@/views/Safety/AdverseEvents";

export default function SingleSubjectAE() {
  const { subjectId } = useParams();
  return <AdverseEvents singleSubjectId={subjectId} />;
}
